import React from "react";
import bgImage from "../../assets/los-angeles.jpg";
import PartnerMarquee from "../helpers/PartnerMarquee";
import VehicleCategories from "../helpers/VehicleCard";
import PopularBrands from "../helpers/PopularBrands";
import RentalSearch from "../helpers/RentalSearch"; // Adjust path if necessary
import TopLocations from "../helpers/TopLocations";
import PopularLocations from "../helpers/PopularLocations";

export default function Home() {
  return (
    <div className="min-h-screen  pb-12 font-sans">
      {/* Hero Header Section */}
      <header
        className="relative mx-2 mt-2 flex min-h-[470px] flex-col justify-center overflow-hidden rounded-[18px] bg-[#0d1d3b] text-center text-white md:mx-3 md:min-h-[clamp(470px,64vh,650px)] md:rounded-[28px] md:bg-[image:var(--hero-bg)] md:bg-cover md:bg-center md:px-[clamp(1rem,6vw,7.5rem)] md:pt-[clamp(2.4rem,6vw,4.5rem)] md:shadow-hero"
        id="top"
        style={{
          "--hero-bg": `linear-gradient(90deg, rgba(9, 38, 107, 0.74) 0%, rgba(42, 88, 183, 0.36) 48%, rgba(6, 12, 27, 0.65) 100%), url(${bgImage})`,
        }}
      >
        {/* Main Content Area */}
        <div className="relative z-10 mx-auto w-full max-w-[1580px]">
          <h1 className="m-0 px-5 pt-4 text-left text-[clamp(1.45rem,7vw,2rem)] font-extrabold leading-tight tracking-normal text-white md:p-0 md:text-center md:text-[clamp(2.05rem,3.7vw,4rem)] md:font-light md:tracking-[0.07em] md:[text-shadow:0_10px_28px_rgba(0,0,0,0.28)]">
            <span className="block">Compare &amp; Save on</span>
            <strong className="mt-1 block text-inherit font-inherit md:text-[clamp(2.55rem,4.5vw,4.9rem)] md:font-extrabold md:tracking-[0.02em]">
              Car Rental
            </strong>
          </h1>

          {/* Imported Rental Search Component */}
          <RentalSearch />
        </div>

        {/* Bottom Banner */}
        <div className="relative mt-5 bg-[#071735] px-4 py-4 text-center text-sm font-extrabold uppercase leading-tight text-white md:mx-[calc(clamp(1rem,6vw,7.5rem)*-1)] md:mt-[clamp(2.3rem,5vw,5.6rem)] md:text-base">
          Find the best car rental deals and book now!
        </div>
      </header>

      {/* Partner Marquee from your original Home */}
      <div className="mt-8">
        <PartnerMarquee />
      </div>
      <div>
        <VehicleCategories />
      </div>
      <div>
        <TopLocations />
      </div>
      <div>
        <PopularLocations />
      </div>
      <div>
        <PopularBrands />
      </div>
    </div>
  );
}
